import { IApplicationState, TFilterId } from '../../../../../types/types';
import { getAuthUserMetaMyWork } from '../../../../../store/model/selectors/getAuthUserMetaMyWork';

export const getMyWorkEnabledFilters = (
    state: IApplicationState
): TFilterId[] => {
    return [...new Set(getAuthUserMetaMyWork(state).enabledFilters)] || [];
};
